import { ENDPOINTS } from "@/settings/api-settings";
import { AxiosResponse } from "axios";
import { Observable, from } from "rxjs";
import { map } from "rxjs/operators";
import { apiClient } from "./api";


export function getRulesDataReport(filters: any): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.RULES_ENGINE_REPORT}`, filters)).pipe(
    map((r: any) => r.data),
  );
}

export function buildRulesXlsReport(filters: any): Observable<AxiosResponse> {
  return from(
    apiClient.download(ENDPOINTS.RULES_ENGINE_REPORT_XLS, filters),
  );
}